import Vue from "vue"
import siteConfig from "@/utils/siteConfig"

export function updateSegment(segment_id, data) {
  return Vue.axios({
    method: "put",
    url: `${siteConfig.siteURL}notifications/segments/${segment_id}`,
    data,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function createSegment(data) {
  return Vue.axios({
    method: "post",
    url: `${siteConfig.siteURL}notifications/segments`,
    data,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function getSegment(segment_id) {
  return Vue.axios({
    method: "get",
    url: `${siteConfig.siteURL}notifications/segments/${segment_id}`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function getSegmentMatchCount(data) {
  return Vue.axios({
    method: "post",
    url: `${siteConfig.siteURL}notifications/segments/evaluate`,
    data,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function duplicateSegment(segment_id) {
  return Vue.axios({
    method: "post",
    url: `${siteConfig.siteURL}notifications/segments/${segment_id}/duplicate`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function createTemplate(data) {
  return Vue.axios({
    method: "post",
    url: `${siteConfig.siteURL}notifications/templates`,
    data,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function getTemplate(template_id) {
  return Vue.axios({
    method: "get",
    url: `${siteConfig.siteURL}notifications/templates/${template_id}`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function updateTemplate(template_id, data) {
  return Vue.axios({
    method: "put",
    url: `${siteConfig.siteURL}notifications/templates/${template_id}`,
    data,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function duplicateTemplate(template_id) {
  return Vue.axios({
    method: "post",
    url: `${siteConfig.siteURL}notifications/templates/${template_id}/duplicate`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function getSegments(query) {
  return Vue.axios({
    method: "get",
    url: `${siteConfig.siteURL}notifications/segments?search=${query}`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function getTemplates(query, type) {
  return Vue.axios({
    method: "get",
    url: `${siteConfig.siteURL}notifications/templates?search=${query}&channel_type=${type}`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function createAnnouncements(data) {
  return Vue.axios({
    method: "post",
    url: `${siteConfig.siteURL}notifications/announcements`,
    data,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function updateAnnouncements(id, data) {
  return Vue.axios({
    method: "put",
    url: `${siteConfig.siteURL}notifications/announcements/${id}`,
    data,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function getAnnouncementDetails(id) {
  return Vue.axios({
    method: "get",
    url: `${siteConfig.siteURL}notifications/announcements/${id}`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function sendAnnouncementPreview(data) {
  console.log("request payload", data)
  return Vue.axios({
    method: "post",
    data,
    url: `${siteConfig.siteURL}notifications/announcements/preview`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function createAutoNotification(data) {
  return Vue.axios({
    method: "POST",
    data,
    url: `${siteConfig.siteURL}notifications/auto`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function getAutoNotificationDetails(id) {
  return Vue.axios({
    method: "GET",
    url: `${siteConfig.siteURL}notifications/auto/${id}`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function updateAutoNotification(id, data) {
  return Vue.axios({
    method: "PUT",
    data,
    url: `${siteConfig.siteURL}notifications/auto/${id}`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function archiveAutoNotificationRule(id) {
  return Vue.axios({
    method: "DELETE",
    url: `${siteConfig.siteURL}notifications/auto/${id}`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function getWhatsAppTemplates() {
  return Vue.axios({
    method: "GET",
    url: `${siteConfig.siteURL}notifications/whatsapp/templates`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}
